// Import api models.
import {
	DisqualifiersTextWithAcknowledgement,
	PossibleDisclosureText,
} from '@app/models/api';

export default class EndorsementPreSubmissionAcknowledgements {

	public disclosures: PossibleDisclosureText[] = [];
	public disqualifierText: DisqualifiersTextWithAcknowledgement | null = null;

	public constructor() {

	}
}